export interface NavItem {
  label: string;
  href: string;
}

export enum Links {
  Home = '/',
  AboutUs = '/about',
  Calculators = '/calculators',
}

export const navigationItems: NavItem[] = [
  { label: 'Home', href: Links.Home },
  { label: 'About Us', href: Links.AboutUs },
  { label: 'Calculators', href: Links.Calculators },
];

export const contactInfo = {
  email: 'amit.mody@moneyqube.in',
  phoneNumber: '919511700434',
};
